<template>
	<div class="goods">
		<v-head :title="title"></v-head>
		<!--<div class="imgBox">
	   	 <img src="../../assets/images/Membership.jpg">
	   </div>-->
		<!-- 团体会员 -->
		<div style="padding:0 10px;" v-if="this.userInfo.memberType==3">
			<div class="car-groupbox group-box" id="carda" v-cloak>
				<ul>
					<li>{{ userInfo.name }}</li>
					<li>{{userInfo.gender==1?"男":"女"}}</li>
					<li>{{userInfo.school}}</li>
					<li>{{ userInfo.memberNo }}</li>
					<li>{{ userInfo.expiryDate | formatDate}}</li>
					<!-- <li>{{ getRecommendUnit(userInfo.recommendUnitId) }}</li> -->
				</ul>
				<template v-if="userInfo.portraitId">
					<div class="portrait" style="width: 96px;height: 169px;" id="demo"
						:style="{ backgroundImage: 'url(' + PZUrl + ')' }"></div>
				</template>
			</div>
		</div>
		<!-- 个人会员 -->
		<div v-else>
			<div class="car-box isSSOC" id="carda" v-cloak>
				<ul>
					<li>{{ userInfo.name }}</li>
					<li>{{userInfo.gender==1?"男":"女"}}</li>
					<li>{{ userInfo.position }}</li>
					<li>{{ userInfo.company }}</li>
					<li>{{ userInfo.memberNo }}</li>
					<li>{{ userInfo.expiryDate | formatDate}}</li>
					<!-- <li>{{ getRecommendUnit(userInfo.recommendUnitId) }}</li> -->
				</ul>
				<template v-if="userInfo.portraitId">
					<div class="portrait" id="demo" :style="{ backgroundImage: 'url(' + PZUrl + ')' }"></div>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		getUser,
		baseURL,
		getPortrait,
		getPZUrl,
		getAssociationCurrent,
		getDictionaryByCode,
		getDuesList,
		getBranchs,
		getPaymentList
	} from "@/api/dictionary";
	import Qrcode from "@xkeshi/vue-qrcode";
	import vHead from "../../components/Subhead.vue";
	import { Uploader, Toast, Button } from "vant";
	import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
	import { getSessionStore } from "@/utils/sessionStorage.js"

	export default {
		data() {
			return {
				codeUrl: 'http://www.csf.org.cn/mobile/#/memberInfo?code=',
				title: "电子会员证",
				fileList: [],
				photoList: [],
				branchList: [],
				page: 1,
				orderAudit: {
					auditTime: '',
				},
				userInfo: {
					id: "",
					name: "未登录",
					memberTypes: ''
				},
				cardName: "card.png",
				componentName: "",
				cardUrl: "",
				PZUrl: "", //头像地址
				singerList: [],
				titleId: '',
				identityTypeList: []
			};
		},
		filters: {
			formatDate: function (value) {
				//   console.log(value)
				// let date = new Date(value);
				if (value) {
					var date = new Date(value.replace(/-/g, '/'));
					let y = date.getFullYear();
					let MM = date.getMonth() + 1;
					MM = MM < 10 ? ('0' + MM) : MM;
					let d = date.getDate();
					d = d < 10 ? ('0' + d) : d;
					let h = date.getHours();
					h = h < 10 ? ('0' + h) : h;
					let m = date.getMinutes();
					m = m < 10 ? ('0' + m) : m;
					let s = date.getSeconds();
					s = s < 10 ? ('0' + s) : s;
					return y + ' 年 ' + MM + ' 月 ' + d + ' 日 ';
				} else {
					return '未成为正式会员';
				}
			}
		},
		components: {
			vHead,
			[Uploader.name]: Uploader,
			[Toast.name]: Toast,
			[Button.name]: Button,
			Qrcode
		},
		computed: {
			...mapState(["zhichengList"]),
			...mapGetters(["commond", "isGroupMember", "getMemberType"])
		},
		methods: {
			...mapActions([
				"getZhiChengList"
			]),
			getAssociationCurrent() {
				getAssociationCurrent().then(res => {
					if (res.success) {
						this.componentName = res.result.name;
					}
				});
			},
			getDisplay(id) {
				getPZUrl({ id }).then(res => {
					if (res.success) {
						this.PZUrl = res.result;
					}
				});
			},
			getTitle() {
				let data = this.identityTypeList
				console.log(data)
				let r = [];
				for (let i = 0; i < data.length; i++) {
					var a = new Object();
					a.text = data[i].label;
					a.id = data[i].value;

					if (data[i].children != null && data[i].children.length > 0) {
						//if(res.result[i].hasOwnProperty("children")){
						let s = [];
						for (let j = 0; j < data[i].children.length; j++) {
							let b = new Object();
							b.text = data[i].children[j].label;
							b.id = data[i].children[j].value;
							s.push(b);
							a.children = s;
							if (this.userInfo.title == b.id) {
								this.titleId = b.text;
								this.userInfo.title = b.id;
								this.activeId = b.id;
								this.activeIndex = a.id;
							}
						}
					}
					r.push(a);
				}
				this.items = r;
			},
			getBranchName(code) {
				let obj = this.branchList.filter(item => item.code == code);
				return obj && obj[0] && obj[0].name;
			},
			getSingerList(params) {
				getDictionaryByCode(params)
					.then(res => {
						this.singerList = res.result;
					})
			},
			getRecommendUnit(val) {
				let obj = this.branchList.find(item => item.code == val);

				if (obj) {
					return obj.name
				} else {
					return '~'
				}
			},
			getBranchs() {
				getBranchs()
					.then(res => {
						if (res.success) {
							this.branchList = res.result
						}

					})
			},
			compare(value) {
				var obj = this.singerList.filter(function (item) {
					return item.value == value;
				});
				if (!obj.length) return '';
				return obj[0].name;
			},
			getOder() {
				const token = getSessionStore("access_token");
				this.loading = true;
				let orderTypeList = [1, 3, 4, 5]
				getPaymentList({ orderTypeList: orderTypeList, "access_token": token }, this.page - 1)
					.then(res => {
						if (res.result.content && res.result.content[0] && res.result.content[0].orderAudit && res.result.content[0].orderAudit.auditTime) {
							this.orderAudit = res.result.content[0].orderAudit;
							//取出时间  转化
						}
					})
					.catch(() => {
						this.$message.error("获取数据失败");
					})
					.finally(() => {
						this.loading = false;
					});


			},
			getUser() {
				return new Promise((resolve, reject) => {
					getUser()
						.then(data => {
							this.userInfo = data.result;
							this.codeUrl = this.codeUrl + this.userInfo.id;
							if (this.userInfo.memberCategory == 1) {
								this.getSingerList('MEMBER_TYPE');
							} else {
								this.getSingerList('GROUP_TYPE');
							}
							resolve(data.result);
						})
						.catch(() => {
							this.$message.error("获取用户信息失败！");
						});
				});
			}
		},
		mounted: async function () {
			getDictionaryByCode("TITLE")
				.then(res => {
					if (res.success) {
						this.identityTypeList = res.result;
						this.getTitle();
					}
				})
			let data = await this.getUser();
			this.getAssociationCurrent();
			this.cardName = data.name + data.memberNo + ".png";
			this.getDisplay(data.portraitId);
			this.getOder();
			this.getBranchs();
			this.getZhiChengList();
		}
	};
</script>

<style lang="less" scoped>
	.imgBox {
		padding: 20px;

		img {
			width: 100%;
		}
	}

	.nav-title {
		display: flex;
		color: #1989fa;
		font-weight: bold;
		align-items: center;

		img {
			width: 17px;
			margin-right: 12px;
		}
	}

	.car-box.isSSOC {
		margin: 10px auto 0;
		height: 540px;
		background: url("../../assets/images/dlgrhy.jpg") center no-repeat;
		background-size: 94%;
		position: relative;

	}

	.car-box.isSSOC ul {
		line-height: 18px;
		transform: rotate(90deg);
		position: absolute;
		left: 47px;
		top: 100px;
		font-family: SimSun;
		font-weight: bold;
	}

	.group-box {
		position: relative;
		height: 540px;
		margin: 20px auto 0;
		background: url("../../assets/images/dlxshy.jpg") center no-repeat;
		background-size: 100%;
	}

	.group-box ul {
		line-height: 18px;
		transform: rotate(90deg);
		position: absolute;
		left: 42px;
		top: 125px;
		font-family: SimSun;
		font-weight: bold;
	}

	.car-box.group-box div {
		position: absolute;
		bottom: 94px;
		left: 44px;
		transform: rotate(90deg);
		line-height: 17px;
	}

	.car-box.group-box div li {
		font-size: 12px;
		min-height: 19px;
		margin-bottom: 6px;
	}

	.car-box ul li.smallBottom {
		margin-bottom: 5px !important;
		font-size: 12px
	}

	.portrait {
		position: absolute;
		width: 106px;
		height: 179px;
		display: block;
		right: 178px;
		bottom: 85px;
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		transform: rotate(90deg);
	}

	.isSSOC ul li {
		min-height: 21px;
		margin-bottom: 13px;
		font-size: 18px;
		color: #000
	}

	.group-box ul li {
		min-height: 22px;
		margin-bottom: 13px;
		font-size: 18px;
		color: #000
	}

	.btn {
		display: block;
		width: 110px;
		height: 38px;
		margin: 38px auto 0;
		font-size: 14px;
		line-height: 38px;
		text-align: center;
		color: #fff;
		border-radius: 3px;
		background: #1989fa;
		cursor: pointer;
	}

	.btn:active {
		background: #1a6fa3;
	}
</style>